<template>
  <fieldset class="mb-0 pb-0">
    <legend v-if="title">
      <h5>
        <strong>{{ title }}</strong>
      </h5>
    </legend>
    <div
      class="form-group"
      :class="[
        {
          'label-floating': label,
          'is-empty': !success && !error && !content,
          'has-success': success && !error,
          'has-error': !success && error,
          'has-disabled': disabled,
          'with-icon': icon,
        },
        otherClasses,
      ]"
    >
      <label v-if="label" class="control-label"
        >{{ label }} <span class="text-danger" v-if="asterisk">*</span>
      </label>
      <input
        class="form-control"
        :type="inputType"
        :min="min"
        :placeholder="placeholder"
        :class="[getSize]"
        :required="required"
        v-on:input="$emit('change', $event.target.value)"
        v-on:keyup.enter="$emit('submit')"
        @keypress="validateInput"
        v-model="content"
        :data-cy="dataCy"
        @focus="$emit('atFocus')"
        @blur="$emit('atBlur')"
        :disabled="disabled"
        ref="input"
        :step="step"
        :name="name"
        :id="dynamicID()"
        :autocomplete="autocomplete"
        :maxlength="max"
      />
      <button class="VuePassword__Toggle" v-if="isSpinner">
        <div
          class="spinner-border spinner-border-sm float-right mt-2"
          role="status"
        >
          <span class="sr-only">Loading...</span>
        </div>
      </button>
      <button
        class="VuePassword__Toggle"
        v-if="isEditable"
        @click="$emit('edit')"
      >
        <img src="/svg-icons/pencil.svg" alt="Edit" />
      </button>
      <ImgTogglePasswordInput v-if="eyeToggle" @visibility="changeVisibility" />
      <PlusUserIcon v-if="plusUser" />
      <em v-if="icon" :class="icon"></em>
      <slot></slot>
    </div>
  </fieldset>
</template>

<script>
// @ is an alias to /src
import ImgTogglePasswordInput from "@/components/atoms/ImgTogglePasswordInput";
import PlusUserIcon from "@/material-components/atoms/PlusUserIcon";
export default {
  name: "SInput",
  props: {
    acceptOnlyLetters: Boolean,
    blockNumbers: Boolean,
    isZipInput: Boolean,
    label: String,
    placeholder: String,
    success: null,
    error: null,
    disabled: Boolean,
    icon: String,
    title: String,
    required: Boolean,
    type: String,
    input: null,
    dataCy: String,
    size: String,
    min: String,
    otherClasses: String,
    eyeToggle: { type: Boolean, default: false },
    isSpinner: { type: Boolean, default: false },
    asterisk: { type: Boolean, default: false },
    plusUser: Boolean,
    isEditable: Boolean,
    step: String,
    name: String,
    autocomplete: String,
    max: Number,
    default: null,
  },
  components: {
    ImgTogglePasswordInput,
    PlusUserIcon,
  },
  data() {
    return {
      content: this.input || null,
      inputType: this.type,
    };
  },
  model: {
    prop: "input",
    event: "change",
  },
  computed: {
    getSize() {
      switch (this.size) {
        case "sm":
          return "form-control-sm";
        case "md-2":
          return "form-control-md-2";
        case "md":
          return "form-control-md";
        case "lg":
          return "form-control-lg";
        default:
          return "";
      }
    },
  },
  watch: {
    input: function (newValue) {
      if (newValue !== this.content) {
        this.content = newValue;
      }
    },
  },
  methods: {
    validateInput(e) {
      const letterRegex = /^[A-Za-z]+$/;
      const numRegex = /^\d+$/;
      const zipRegex = /^[0-9-]+$/;
      if (e.type === "paste" && this.blockNumbers) {
        e.preventDefault();
      }
      if (e.type === "keypress") {
        if (this.acceptOnlyLetters && !e.key.match(letterRegex)) {
          e.preventDefault();
        }
        if (this.blockNumbers && e.key.match(numRegex)) {
            e.preventDefault();
        }
        if (this.isZipInput && !e.key.match(zipRegex)) {
            e.preventDefault();
        }
      }
    },
    changeVisibility(e) {
      if (e) {
        this.inputType = "text";
      } else {
        this.inputType = "password";
      }
    },
    dynamicID() {
      return "dynamicID-" + Math.floor(Math.random() * Date.now().toString());
    },
  },
  mounted() {
    this.$refs.input.blur();
  },
};
</script>
<style lang="scss" scoped>
.fa-solid.fa-user-plus {
  color: black !important;
}
</style>
